import React, { useContext, useState } from 'react'
import classnames from 'classnames'
import { useLocation } from 'react-router-dom'
import { DepartmentContext } from '#src/context/department'
import { Notifier, NewMessageEvent } from '@deal/chat-firebase'
import BottomAppBar from '../BottomAppBar'
import BottomAppBarLinkItem from '../BottomAppBarLinkItem'
import ChatTab, { ChatTabDisplay } from '../ChatTab'
import AccountIcon from './account.svg'
import BrowseIcon from './browse.svg'
import ChatIcon from './chat.svg'
import CurationsIcon from './curations.svg'
import styles from './styles.css'

interface TabBarProps {
  expertId?: string
  recipientIds?: string[]
  conversationId?: string
  hide?: boolean
}

const TabBar: React.SFC<TabBarProps> = ({ expertId, recipientIds, conversationId, hide }) => {
  const { department } = useContext(DepartmentContext)
  const location = useLocation()
  const [chatDisplay, setChatDisplay] = useState(ChatTabDisplay.Collapsed)

  const handleNewMessage = ({ context }: NewMessageEvent) => {
    if (context === 'conversation' && chatDisplay === ChatTabDisplay.Collapsed) {
      setChatDisplay(ChatTabDisplay.Previewed)
    }
  }

  return (
    <>
      <BottomAppBar
        role="navigation"
        className={classnames(styles.tabBar, { [styles.hide]: hide })}
      >
        <Notifier
          conversationId={conversationId}
          recipientIds={recipientIds}
          onNewMessage={handleNewMessage}
        >
          {({ unreadMessageCount }) => {
            const showUnreadCount = conversationId || recipientIds

            return (
              <BottomAppBarLinkItem
                to={location}
                onClick={() => setChatDisplay(ChatTabDisplay.Expanded)}
                icon={ChatIcon}
                badge={
                  showUnreadCount && unreadMessageCount ? unreadMessageCount.toString() : undefined
                }
                isActive={() => chatDisplay !== ChatTabDisplay.Collapsed}
              >
                My expert
              </BottomAppBarLinkItem>
            )
          }}
        </Notifier>
        <BottomAppBarLinkItem to="/curations" icon={CurationsIcon}>
          My curations
        </BottomAppBarLinkItem>
        <BottomAppBarLinkItem
          to={department ? `/d/${department.slug}` : '/'}
          icon={BrowseIcon}
          isActive={(_match, location) => {
            return (
              location.pathname.startsWith('/d/') ||
              location.pathname.startsWith('/c/') ||
              location.pathname.startsWith('/products/') ||
              location.pathname.startsWith('/experiences/')
            )
          }}
        >
          Browse
        </BottomAppBarLinkItem>
        <BottomAppBarLinkItem to="/account" icon={AccountIcon}>
          Account
        </BottomAppBarLinkItem>
      </BottomAppBar>

      <ChatTab
        display={chatDisplay}
        onDisplayChanged={setChatDisplay}
        expertId={expertId}
        recipientIds={recipientIds}
        conversationId={conversationId}
      />
    </>
  )
}

export default TabBar
